import { FEATURE_FLAGS } from '@vizit/constants';
import { useFeatureFlag } from './use-feature-flag';

/**
 * SPM-3405: returns whether the image navigation buttons should be shown.
 *
 * Defaults to `false` — the "Jump to image" and "Back to source image"
 * controls stay hidden until the flag is explicitly enabled.
 */
function useShowImageNavigation(): boolean {
  return useFeatureFlag(FEATURE_FLAGS.SHOW_IMAGE_NAVIGATION, false);
}

export { useShowImageNavigation };
